<template>
<div class="list-page-header">
  <div class="list-left">
    <h3 class="title">{{$t('My_Points')}}</h3>
    <img
      width="18px"
      src="../../assets/images/userCenter/integral.png"
      alt=""
    >
    <span class="integral-number">{{carInfo.rewardPoint}}</span>
  </div>
  <div class="list-right display-flex flex-end">
    <span class="label">{{$t('integralShop.sort_by')}}</span>
    <el-select
      size="mini"
      v-model="sort"
      style="width: 130px"
      class="select-box"
      @change="sortChange"
    >
      <el-option
        v-for="(item,index) in sortList"
        :key="index"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
    <div
      @click="openShopCarHandle"
      class="icon-outer shop-car pr">
      <i class="el-icon-data-line iconfont icon-gouwuche icon-el"></i>
      <div
        v-if="carInfo.cartSize"
        class="shop-car-number pa">
        {{carInfo.cartSize}}
      </div>
    </div>
    <div
      @click="locationHandle"
      class="icon-outer location">
      <i class="el-icon-location-outline iconfont icon-shouhuodizhi icon-el"></i>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'listPageHeader',
  props: {
    carInfo: {
      type: Object,
      default(){
        return {

        }
      }
    }
  },
  data() {
    let _this = this;
    return {
      sort: 2,
      sortList:[
        {label: _this.$t('Sales'),value: 1},
        {label: _this.$t('integral'),value: 2},
      ],
    };
  },
  methods: {
    locationHandle(){
      this.$emit('location-click');
    },
    sortChange() {
      this.$emit('sort-change');
    },
    openShopCarHandle(){
      this.$emit('open-shopcar');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variable";
.list-page-header {
  height: 70px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  .list-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .title {
      font-weight: 600;
      font-size: 18px;
      margin-right: 10px;
    }
    .icon-el {
      margin-left: 10px;
      margin-right: 5px;
    }
    .integral-number {
      font-size: 18px;
      margin-left: 5px;
    }
  }
  .list-right {
    .select-box {
      margin: 0 5px;
    }
    .label {
      color: #999999;
      font-size: 14px;
    }
    .icon-outer {
      cursor: pointer;
      width: 28px;
      height: 28px;
      border: 1px solid #E6E6E6;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #333333;
      &.location {
        margin-left: 5px;
      }
      &.shop-car {
        .shop-car-number {
          height: 15px;
          width: 15px;
          border-radius: 50%;
          background-color: $themeColor;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          top: -10px;
          right: -5px;
          color: #ffffff;
          font-size: 12px;
        }
      }
    }
  }
  .icon-el {
    font-size: 20px;
  }
}
@media screen and (max-width: 750px){
  .list-page-header {
    padding-left: 20px;
    padding-right: 20px;
  }
}

</style>
